import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { AdminContext } from "../../contexts/AdminContext";
import cookie from "cookiejs";
import { useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import { Center, Text, Flex } from '@chakra-ui/react'
import CustomButton from "../custom/Button";

const Logout: React.FC = () => {
  const { setIsAuthenticated } = useContext(AuthContext)
  const { setAdmin } = useContext(AdminContext)
  const navigate = useNavigate();

  function logout() {
    cookie.remove('eden_admin')
    setTimeout(() => {
      setIsAuthenticated(false)
      setAdmin(null)
      navigate('/signin')
    }, 500)
  }

  const buttonStyles = {
    width: '170px',
    textAlign: 'left',
    color: 'white',
    borderRadius: '5px',
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop: '10px',
    paddingBottom: '10px',
    fontWeight: 'bold',
    fontSize: '18px',
    backgroundColor: 'transparent',
  };
  return (
    <Center w="100%" h="60px">
      <CustomButton onClick={logout} style={buttonStyles}>
        <Flex alignItems='center' gap='6px'>
          <Icon
            icon='material-symbols:logout' color="white"
            width="18" height="18"
          />

          <Text>Logout</Text>
        </Flex>
      </CustomButton>
    </Center>
  )
}

export default Logout